import fire from '..';

type Props = {
  collectionRef: string;
  query?: string;
  limit?: number;
};
export async function deleteCollection({ collectionRef, query, limit }: Props) {
  const firestore = fire.firestore();

  return new Promise((resolve, reject) => {
    deleteQueryBatch(firestore, collectionRef, resolve).catch(reject);
  });
}

async function deleteQueryBatch(db, query, resolve) {
  const snapshot = await query.get();

  const batchSize = snapshot.size;
  if (batchSize === 0) {
    // When there are no documents left, we are done
    resolve();
    return;
  }

  // Delete documents in a batch
  const batch = db.batch();
  snapshot.docs.forEach((doc) => {
    batch.delete(doc.ref);
  });
  await batch.commit();

  // Recurse on the next process tick, to avoid
  // exploding the stack.
  // if (process) {
  //   process.nextTick(() => {
  //     deleteQueryBatch(db, query, resolve);
  //   });
  // }

  return;
}
